window.TechHonestyOpenSearchFallback = function () {
  window.setTimeout(function () {
    var modal = document.querySelector('#search-modal');
    var dialog = modal && modal.querySelector('dialog');
    var input = modal && modal.querySelector('input[type="search"], input[name="q"], input[placeholder]');

    if (!dialog || dialog.open) return;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    if (input && typeof input.focus === 'function') input.focus();
  }, 0);
};

document.addEventListener(
  'click',
  function (event) {
    var button = event.target && event.target.closest && event.target.closest('.search-modal__button');

    if (!button) return;

    window.TechHonestyOpenSearchFallback();
  },
  true
);
